<script lang="ts">
	const { title, showFormLabel, emptyLabel } = $props();
	let cart: HTMLDivElement | null | undefined = $state();
	let closeButton: HTMLButtonElement | null | undefined = $state();
	let cartIsVisible = $state(false);
	let showForm = $state(false);

	let items: string[] = $state(
		JSON.parse(localStorage.getItem('cart') || '[]'),
	);
	document.addEventListener('cartchange', async () => {
		items = JSON.parse(localStorage.getItem('cart') || '[]');
	});

	const remove = (item: string) => {
		items = items.filter((i: string) => i !== item);
		localStorage.setItem('cart', JSON.stringify([...new Set(items)]));
	};

	$effect(() => {
		const hiddenInput = document.querySelector(
			"textarea[name='message[body]']",
		) as HTMLInputElement | null | undefined;
		if (hiddenInput) {
			hiddenInput.value = items.length
				? '\n\n**Produkte**\n\n' + items.map(i => `  - ${i}`).join('\n')
				: '';
		}
	});
	$effect(() => {
		if (cartIsVisible && cart) {
			cart.showPopover();
			closeButton?.focus();
		}
	});

	$effect(() => {
		if (showForm) {
			const form = $host()
				.shadowRoot?.querySelector('slot')
				?.assignedElements()
				.find(e => e.tagName === 'FORM') as HTMLFormElement | undefined;

			if (!cartIsVisible && items.length === 0) {
				showForm = false;

				if (form) {
					form.hidden = false;
					const output = (form.querySelector("[role='status']") ??
						form.nextElementSibling) as HTMLElement | null;
					if (output) {
						output.innerHTML = '';
						output.hidden = true;
					}
				}
			}

			form?.addEventListener(
				'submit',
				e => {
					if (items.length === 0) {
						e.preventDefault();
						e.stopImmediatePropagation();
						alert('Cart is empty');
					}
				},
				{ capture: true }, // Use capture to fire before other 'submit' events
			);

			form?.addEventListener('success', () => {
				items = [];
				localStorage.setItem('cart', JSON.stringify([...new Set(items)]));
			});
		}
	});
</script>

<svelte:options
	customElement={{
		tag: 'shopping-cart',
		shadow: 'open',
	}}
/>

<button
	class="cart-toggle"
	aria-pressed={cartIsVisible}
	aria-controls="cart"
	onclick={() => {
		cartIsVisible = !cartIsVisible;
	}}
	hidden={cartIsVisible}
	>{title}
	{#if items.length}
		<sup>{items.length}</sup>
	{/if}
</button>

<div
	class={`overlay ${showForm ? 'form-is-visible' : ''}`}
	popover="manual"
	id="cart"
	bind:this={cart}
	hidden={!cartIsVisible}
>
	<div class="flow">
		<header>
			{title}
			<button
				bind:this={closeButton}
				onclick={() => {
					cartIsVisible = false;
				}}
			>
				<span class="visually-hidden">Close</span>
				×
			</button>
		</header>

		{#if items.length}
			<ul role="list">
				{#each items as item}
					<li>
						{item}

						<button
							onclick={() => {
								remove(item);
							}}
						>
							<span class="visually-hidden">Remove {item}</span>
							×
						</button>
					</li>
				{/each}
			</ul>

			<button
				id="formToggle"
				aria-pressed={showForm}
				aria-controls="slot"
				onclick={() => {
					showForm = !showForm;
				}}>{showFormLabel}</button
			>
		{:else}
			<p>{emptyLabel}</p>
		{/if}
	</div>
	<div id="slot" aria-labelledby="formToggle">
		{#if showForm}
			<slot />
		{/if}
	</div>
</div>

<style lang="postcss">
	@import '../../css/blocks/overlay';
	@import '../../css/composition/flow';
	@import '../../css/utilities/visually-hidden';

	.toggle {
		anchor-name: --cart;
		position: fixed;
		right: var(--padding-inline);
		border: none;
	}

	[popover]:not([hidden]) {
		overscroll-behavior: contain;
		border: none;
		overflow-y: auto;
		overflow-x: clip;
		max-height: calc(100svh - 72px - var(--padding-inline));
		position: fixed;
		padding: 0.5rem 0.875rem;
		position: fixed;
		position-anchor: --cart;
		top: 72px;
		right: var(--padding-inline);
		left: unset;
		margin: 0;
		font-size: var(--size-xs);
		box-sizing: border-box;
		grid-template-columns: 100%;
		gap: 0.75rem;
		width: min(
			calc(100% - 2 * var(--padding-inline)),
			28.3125rem + 2 * 0.875rem
		);

		> :first-child {
			width: 100%;
			justify-self: end;
			grid-row: 1;
		}

		&:popover-open {
			display: grid;
		}

		&.form-is-visible {
			width: calc(100% - 2 * var(--padding-inline));
			padding-bottom: 2rem;

			@screen lg {
				grid-template-columns:
					repeat(auto-fill, minmax(min(100%, 28.3125rem), 1fr))
					min(100%, 28.3125rem);
			}

			> :first-child {
				grid-column: -2 / -1;
			}
		}
	}

	ul {
		list-style: none;
		position: relative;
		padding-left: 3ch;
		border-top: 1px solid var(--color-gray-200);
		padding-top: 0.5rem;
	}

	li {
		display: flex;
		gap: 1ch;
		align-items: center;
	}

	li button {
		margin-left: auto;
		text-decoration: none;
	}

	li::before {
		content: '1×';
		position: absolute;
		left: 0;
	}
	#slot {
		display: contents;
	}
	:global(::slotted(*)) {
		grid-column: 1 / -2;
		grid-row: 2;

		@screen lg {
			grid-row: 1;
		}
	}

	button {
		appearance: none;
		border-color: transparent;
		background-color: transparent;
		cursor: pointer;
		color: currentColor;
		text-transform: uppercase;
		text-decoration: underline;
		margin-inline: -6px;
	}

	header {
		font-size: var(--size-base);
		display: flex;
		align-self: center;

		button {
			font-size: var(--size-base);
			display: inline;
			margin-left: auto;
			text-decoration: none;
		}

		+ * {
			--flow-space: utopia.clamp(48, 96);
		}
	}
	.cart-toggle {
		font-size: var(--size-base);
		cursor: pointer;
		padding: 0.5rem;
		text-decoration-line: none;
		text-transform: none;
		border-radius: var(--radius);
		backdrop-filter: blur(20px) brightness(50%);
		background-color: transparent;
		z-index: 20;
		color: var(--color-white);
		position: fixed;
		top: 72px;
		right: calc(var(--padding-inline) + 6px);
		left: unset;

		@media (prefers-reduced-transparency: reduce) {
			backdrop-filter: none;
			background-color: var(--color-gray-400);
		}

		sup {
			font-feature-settings: 'tnum';
			margin-top: -0.26979375rem;
			display: inline-block;
			font-size: var(--size-xs);
		}
	}
</style>
